import React, { useState } from 'react';
import { Button, Col, Modal, Row, DatePicker, Typography } from 'antd';
import { useSelector, useDispatch } from 'react-redux';


import { CalendarOutlined } from '@ant-design/icons';
import Auxiliary from '../util/Auxiliary';
import { setDateRange } from '../redux/actions/Date';

const { RangePicker } = DatePicker;
const { Text } = Typography;

const DateRange = () => {
  const dispatch = useDispatch();

  const [dateRangeModal, setDateRangeModal] = useState(false);
  const [dateRangeError, setDateRangeError] = useState(null);
  const { dateRange } = useSelector(({ date }) => date);

  const openDateRange = () => {
    setDateRangeModal(true);
  };

  const handleCancel = () => {
    setDateRangeModal(false);
  };

  const onDateRangeChanged = () => {
    setDateRangeModal(false);
  };

  const handleChangeDateRange = (value) => {
    dispatch(setDateRange(value));
  };

  return (
    <Auxiliary>
      <Row>
        <Col xl={20} lg={20} md={20} sm={20} xs={20}>
          <h2 className="title gx-mb-3">
            {dateRange
              && (
                <span>
                  (
                  {dateRange.startDate}
                  {' '}
                  to
                  {' '}
                  {dateRange.endDate}
                  )
                </span>
              )}
          </h2>
        </Col>
        <Col xl={4} lg={4} md={4} sm={4} xs={4}>
          <Button style={{ float: 'right' }} title="Date Range" type="default" icon={<CalendarOutlined />} onClick={openDateRange} />
        </Col>
      </Row>

      <Modal
        title="Select date range"
        open={dateRangeModal}
        onOk={onDateRangeChanged}
        onCancel={handleCancel}
      >
        {
          dateRangeError && <Text type="danger">{dateRangeError}</Text>
        }
        <RangePicker onChange={(_, dateString) => handleChangeDateRange(dateString)} style={{ width: '100%' }} />
      </Modal>

    </Auxiliary>
  );
};

export default DateRange;
